import Theme from "../components/Theme";
import People from "../components/organisms/common/People";
import WideCTA from "../components/organisms/common/WideCTA";
import AppStorage from "../components/AppStorage";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../styles/cssinjs/helpers/variables.js";

export async function getServerSideProps({ locale }) {
  let allData = {};

  const headerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/header.json`
  );

  const footerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/footer.json`
  );

  const marketingResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/privacy/marketing.json`
  );

  const contentResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/privacy/content.json`
  );

  // Catch Error
  if (!marketingResponse.ok || !contentResponse.ok) {
    return {
      notFound: true,
    };
  }

  // Convert
  allData.header = await headerResponse.json();
  allData.footer = await footerResponse.json();
  allData.marketing = await marketingResponse.json();
  allData.content = await contentResponse.json();

  // Wrap
  const header = {
    header: allData.header,
  };
  const footer = {
    footer: allData.footer,
  };
  // Combine all data
  const data = await {
    ...header,
    ...footer,
    ...allData.marketing,
    ...allData.content,
  };

  return {
    props: {
      data,
      fallback: false,
    },
  };
}

const Title = ({ title, desc }) => (
  <article className="lg:maxw-lg mx-auto">
    <h1 className="text-xl" dangerouslySetInnerHTML={{ __html: title }} />
    <p>{desc}</p>
  </article>
);

const PolicyList = ({ data }) => {
  return data.map((terms) => (
    <article key={terms.id} className="lg:maxw-lg mx-auto">
      <h2 id={terms.id}>{terms.title}</h2>
      {Array.isArray(terms.desc) ? (
        terms.desc.map((para, index) => (
          <p
            className={`${index != 0 && "mt-2"}`}
            key={`${terms.id}_${index}`}
            dangerouslySetInnerHTML={{ __html: para }}
          />
        ))
      ) : (
        <p dangerouslySetInnerHTML={{ __html: terms.desc }} />
      )}
    </article>
  ));
};

const PeopleBannerText = ({ data }) => (
  <section className="md:mb-5 lg:mb-10 mx-auto">
    <h2 className="text-xl text-center">
      <span>{data}</span> <span className="md:d-block emoji">❤️</span>{" "}
      <span>Setmore</span>
    </h2>
  </section>
);

export default function Privacy({ data }) {
  const { header, footer, seo, content, pages } = data;
  return (
    <Theme header={header} footer={footer} seo={seo} className="bg-light">
      <AppStorage pageName="Privacy Page" />
      <section className="lg:pb-10 md:pb-5 sm-terms-privacy container">
        <Title title={content.title} desc={content.desc} />
        <PolicyList data={content.list} />
      </section>
      <PeopleBannerText data={content.peopleBannerText} />
      <People />
      <WideCTA data={content.wideCTA} />
      <style jsx>{`
        :global(body) {
          background-color: ${colors.primitive.black[200]}!important;
        }
      `}</style>
    </Theme>
  );
}
